import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import PlayerCardButton from "./PlayerCardButton/PlayerCardButton";

const SelectChangePlayers = ({
  eventDetails,
  setEventDetails,
  changeCallback,
  confirmCallback,
  skipCallback,
  isShootout,
  initialEvent
}) => {
  return (
    <div
      style={{
        padding: "10px 30px",
        display: "flex",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          backgroundColor: "transparent",
          border: "1px solid black",
          height: 35,
          width: 35,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 20,
        }}
      >
        <Icon name="su-user" />
      </div>

      {eventDetails?.playerSelected && (
        <div
          style={{
            width: "50%",
            display: "flex",
          }}
        >
          <button
            style={{
              border: "2px solid black",
              borderRadius: 5,
              height: 45,
              backgroundColor: eventDetails?.sideSelected?.teamColor,
              fontWeight: "700",
              fontSize: "16px",
              width: "70%",
              marginRight: 30,
              position: "relative",
            }}
          >
            <span
              style={{
                marginRight: 10,
              }}
            >
              {eventDetails?.playerSelected?.playerNumber}
            </span>

            <span>{eventDetails?.playerSelected?.playerName || eventDetails?.playerSelected?.contactName}</span>
            {(eventDetails?.playerSelected?.cards || []).includes("GELB") && (
              <div
                style={{
                  backgroundColor: "#F8D200",
                  height: 10,
                  width: 10,
                  borderRadius: 2.5,
                  position: "absolute",
                  right: 2,
                  bottom: 2,
                }}
              />
            )}

            {(eventDetails?.playerSelected?.cards || []).includes(
              "GELB ROT"
            ) && (
              <div
                style={{
                  background:
                    "linear-gradient(-45deg, #FF0014 50%, #F8D200 50%)",
                  height: 10,
                  width: 10,
                  borderRadius: 2.5,
                  position: "absolute",
                  right: 2,
                  bottom: 2,
                }}
              />
            )}
            {(eventDetails?.playerSelected?.cards || []).includes(
                  "ROT"
              ) && (
                  <div
                      style={{
                          backgroundColor: "#FF0014",
                          height: 10,
                          width: 10,
                          borderRadius: 2.5,
                          position: "absolute",
                          right: 2,
                          bottom: 2,
                      }}
                  />
            )}
          </button>
          {eventDetails.quarterSelected !== 'SO' &&
          <button
              style={{
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: "16px",
              }}
              onClick={() => {
                setEventDetails((data) => {
                    return {
                      ...data,
                      playerSelected: null,
                      ...(eventDetails?.type?.name === "GELB ROT" ? {type: initialEvent.current.type} : {})
                  }
                  });
                  changeCallback && changeCallback();
              }}
          >
              X
              <span
                  style={{
                      border: "none",
                      backgroundColor: "transparent",
                      fontSize: "16px",
                      textDecoration: "underline",
                      marginLeft: 5,
                  }}
              >
              Ändern
            </span>
          </button>
          }
        </div>
      )}

      {!eventDetails?.playerSelected && (
        <div
          style={{
            width: "85%",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "80%",
              marginRight: 30,
            }}
          >
            <h3 style={{paddingTop: '0.5em'}}>Spielerinnen</h3>
            <div  
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridGap: "10px",
            }}>
              {eventDetails?.sideSelected?.players?.map((player) => {
                return <PlayerCardButton
                setEventDetails={setEventDetails}
                key={player?.id} 
                eventDetails={eventDetails} 
                confirmCallback={confirmCallback} 
                player={player} 
                initialEvent={initialEvent}
                isStaff={false}
              />
              })}
            </div>
          </div>
          {skipCallback && !isShootout ? (
            <button
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "16px",
              }}
              onClick={() => {
                setEventDetails((data) => ({
                  ...data,
                  playerSelected: false,
                }));
                skipCallback && skipCallback();
              }}
            >
              X
              <span
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: "16px",
                  textDecoration: "underline",
                  marginLeft: 5,
                }}
              >
                Überspringen
              </span>
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default SelectChangePlayers;
